export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-white mb-2">Terminos y Condiciones de Servicio</h1>
        <p className="text-sm text-zinc-500 mb-10">Ultima actualizacion: 12 de junio de 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. Identificacion del Prestador</h2>
            <p><strong>Titular:</strong> RAUL HORACIO OSTENGO</p>
            <p><strong>CUIT:</strong> 20-26638702-5</p>
            <p><strong>Domicilio:</strong> San Martin 839, Piso 3, Depto A - Entre calles Salta y Junin, San Miguel de Tucuman (4000), Tucuman, Argentina</p>
            <p><strong>Telefono:</strong> +54 9 381 414 9687</p>
            <p><strong>Sitio web:</strong> https://rcsender.com</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Descripcion del Servicio</h2>
            <p>RCS Sender es una plataforma SaaS (Software como Servicio) que permite a sus usuarios gestionar el envio masivo de mensajes a traves de:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>RCS (Rich Communication Services):</strong> Via extension de Google Chrome integrada con Google Messages.</li>
              <li><strong>WhatsApp:</strong> Via aplicacion Android dedicada.</li>
            </ul>
            <p className="mt-2">La plataforma incluye gestion de campanas, contactos, plantillas de mensajes, reportes analiticos, sistema anti-ban, y API REST para integraciones externas.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. Aceptacion de los Terminos</h2>
            <p>Al registrarse, acceder o utilizar RCS Sender, el usuario acepta estos terminos y condiciones en su totalidad. Si no esta de acuerdo, debe abstenerse de utilizar el servicio.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Registro y Cuenta</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>El acceso requiere autenticacion via Google OAuth.</li>
              <li>El usuario es responsable de mantener la seguridad de su cuenta.</li>
              <li>El usuario debe proporcionar informacion veraz y actualizada.</li>
              <li>El acceso a la plataforma puede estar sujeto a aprobacion previa.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Uso Aceptable</h2>
            <p>El usuario se compromete a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Utilizar el servicio de manera licita y conforme a la legislacion vigente.</li>
              <li>Obtener el consentimiento previo de los destinatarios de los mensajes.</li>
              <li>No enviar contenido ilegal, fraudulento, difamatorio, amenazante o spam.</li>
              <li>No utilizar el servicio para phishing, estafas o actividades maliciosas.</li>
              <li>Respetar las politicas de uso de Google Messages y WhatsApp.</li>
              <li>No intentar eludir las limitaciones tecnicas o de seguridad de la plataforma.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Responsabilidad del Usuario</h2>
            <p>El usuario es el unico responsable de:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>El contenido de los mensajes enviados a traves de la plataforma.</li>
              <li>La legalidad del uso de las listas de contactos cargadas.</li>
              <li>El cumplimiento de las normativas de proteccion de datos personales aplicables.</li>
              <li>Cualquier consecuencia derivada del uso indebido del servicio.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">7. Limitacion de Responsabilidad</h2>
            <p>RCS Sender no garantiza:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>La entrega exitosa de todos los mensajes (depende de factores externos como el operador del destinatario, disponibilidad de RCS, estado de WhatsApp).</li>
              <li>La disponibilidad ininterrumpida del servicio.</li>
              <li>Que el servicio estara libre de errores.</li>
            </ul>
            <p className="mt-2">RCS Sender no sera responsable por danos indirectos, incidentales, especiales o consecuentes derivados del uso del servicio.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">8. Propiedad Intelectual</h2>
            <p>Todo el software, diseno, logotipos, y contenido de la plataforma son propiedad de RCS Sender / Ostengo Raul Horacio. El usuario no adquiere ningun derecho de propiedad intelectual sobre la plataforma.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">9. Suspension y Terminacion</h2>
            <p>Nos reservamos el derecho de suspender o cancelar la cuenta de cualquier usuario que:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Viole estos terminos y condiciones.</li>
              <li>Utilice el servicio para actividades ilegales.</li>
              <li>Ponga en riesgo la integridad del servicio o de otros usuarios.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">10. Modificaciones</h2>
            <p>Nos reservamos el derecho de modificar estos terminos en cualquier momento. Los cambios seran notificados a traves de la plataforma y entraran en vigencia al ser publicados.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">11. Legislacion Aplicable</h2>
            <p>Estos terminos se rigen por las leyes de la Republica Argentina. Cualquier controversia sera sometida a la jurisdiccion de los tribunales ordinarios de San Miguel de Tucuman, provincia de Tucuman.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">12. Contacto</h2>
            <p><strong>RAUL HORACIO OSTENGO</strong></p>
            <p>San Martin 839, Piso 3, Depto A - Entre calles Salta y Junin</p>
            <p>San Miguel de Tucuman (4000), Tucuman, Argentina</p>
            <p>CUIT: 20-26638702-5</p>
            <p>Telefono: +54 9 381 414 9687</p>
            <p>Email: soporte@rcsender.com</p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-xs text-zinc-600">
          <p>&copy; {new Date().getFullYear()} RCS Sender — RAUL HORACIO OSTENGO. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
}
